import * as styles from './PlanMobile.css'

export function PlanMobile() {
  return (
    <a href={`/LIAN_Ne25_Webseite_Plan_A3_WEB.pdf`} target="_blank" rel="noreferrer">
      <img src="/LIAN_Ne25_Webseite_Plan.svg" alt="Hallenplan 2025" width="800" height="auto" css={styles.image} />
    </a>
  )
}
